import {fromJS} from 'immutable'
import type { ExtractReturn } from '../../util/extractReturn'
import { PROCESS_JOURNEY } from './journey'
import { TOGGLE_VOTE } from './content'
import { PROCESS_TOPIC } from './topic'
import { PROCESS_PROBLEM,BATCH_POSTED,ADJUST_CURR_STREAK } from './grandmaster'
import { denormalize, normalize } from 'normalizr'
import {get} from '../../util/http'
import * as schema from '../schema'

/**
 * Actions
 */
const MERGE_ENTITIES = 'expii/entities/MERGE_ENTITIES'

/**
 * Reducer
 */
const defaultEntitiesState = fromJS({})

export default function reducer(state = defaultEntitiesState, action: Actions) {
  switch (action.type) {
  case MERGE_ENTITIES:
  case PROCESS_JOURNEY:
  case PROCESS_PROBLEM:
  case PROCESS_TOPIC:
    return state.mergeDeep(fromJS(action.payload.entities))
  case TOGGLE_VOTE:
    const {currentUserHasVoted, voteCount, type, id} = action.payload
    const newVote = {
      currentUserHasVoted: currentUserHasVoted,
      voteCount: voteCount
    }
    return state.mergeIn(
      [type, `${id}`],
      newVote
    )
  case BATCH_POSTED:
    return state.withMutations(s => {
      for (let topic_id in action.new_scores) {
        s = s.setIn(['topic',topic_id,'scores'],action.new_scores[topic_id])
      }
      return s
    })
  case ADJUST_CURR_STREAK:
    if (action.increment) {
      if (state.getIn(['gmProblem',action.gmProblem,'streak']) === state.getIn(['gmProblem',action.gmProblem,'bestStreak'])) {
        return state.withMutations(s => {
          s = s.updateIn(['gmProblem',action.gmProblem,'streak'],(n) => n+1)
          s = s.updateIn(['gmProblem',action.gmProblem,'bestStreak'],(n) => n+1)
          s = s.setIn(['gmProblem',action.gmProblem,'gotCorrect'],true)
          return s
        })
      } else {
        return state.withMutations(s => {
          s = s.updateIn(['gmProblem',action.gmProblem,'streak'],(n) => n+1)
          s = s.setIn(['gmProblem',action.gmProblem,'gotCorrect'],true)
          return s
        })
      }
    } else {
      return state.withMutations(s => {
        s = s.setIn(['gmProblem',action.gmProblem,'streak'],0)
        s = s.setIn(['gmProblem',action.gmProblem,'gotCorrect'],false)
        return s
      })
    }
  default:
    return state
  }
}

/**
 * Action Creators
 */
export function mergeEntities(entities: Object) {
  return { type: MERGE_ENTITIES, payload: entities }
}

/**
 * Side Effects
 */
export function fetchContentEntity(entityType, contentId) {
  return (dispatch, getState) => {
    return get(`/api/content/${entityType}/${contentId}`)
      .then(json => {
        const {output} = json
        const normalized = normalize(output, schema[entityType])
        dispatch(mergeEntities(normalized))
      })
  }
}
export function fetchTopic(topicId) {
  return (dispatch, getState) => {
    if (topicId && topicId !== -1) {
      return get(`/api/v2/topic/${topicId}`)
        .then(json => {
          const {output} = json
          const normalized = normalize(output, schema.topic)
          dispatch(mergeEntities(normalized))
        })
    }
  }
}

/**
 * Selectors
 */
export const denormalizeEntity = (state, input, schema) => {
  const entities = state.get('entities')
  return denormalize(input, schema, entities)
}

export const getEntity = (state, domain, id) => {
  const domainEntities = state.get('entities').get(domain)
  if (domainEntities && domainEntities.has(id)) {
    return domainEntities.get(id)
  }
  return false
}

export const entityExists = (state, domain, id) => {
  const domainEntities = state.get('entities').get(domain)
  if (domainEntities) {
    return domainEntities.has(id)
  }
  return false
}

export const selectEntities = state => {
  return state.getIn(['entities'])
}

export type Actions = ExtractReturn<typeof mergeEntities>;



// WEBPACK FOOTER //
// ./src/redux/modules/entities.js